import React from "react";
import { Route, Redirect } from "react-router-dom";
import Template from "./Template";

const PrivateRoute = ({ component, ...props }) => (
  <Route
    {...props}
    render={() =>
      localStorage.getItem("access_token") ? (
        <Template component={component} {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

export default PrivateRoute;
